import { useState } from 'react';
import { useCallback } from 'react';
import { InputActionMeta } from 'react-select';

interface OnInputChange {
  (newValue: string, actionMeta: InputActionMeta): void;
}

interface Params<Option> {
  value: Option[];
  isLoading: boolean;
}

export const useInputValue = <Option>({ value, isLoading }: Params<Option>) => {
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = useCallback<OnInputChange>(
    (newInputValue: string, { action }) => {
      /*
       * Хук на изменение значения поля ввода селектором (ввод с клавиатуры)
       */
      if (action === 'input-change') {
        setInputValue(newInputValue);
      }
      /*
       * При уходе фокуса с поля ввода, если значение не установлено и селектор не в состоянии загрузки,
       * то сбрасываем значение поля ввода
       */
      if (action === 'input-blur' && !value && !isLoading) {
        // setInputValue('');
      }
    },
    [value, isLoading],
  );

  const resetInputValue = useCallback(() => {
    if (inputValue) {
      setInputValue('');
    }
  }, [inputValue]);

  return {
    inputValue,
    onInputChange: handleInputChange,
    resetInputValue,
  };
};
